export default __webpack_public_path__ + "static/media/X3 LOGOTIPO-COR-02.a1e07595.png";